import React from 'react';
import { Box, Button } from 'theme-ui';
import theme from '../../utilities/brandTheme';

export default function Product({
  image, 
  alt,
  title1,
  title2,
  subtitle,
  buttonText,
  strikedPrice,
  price,
  bottomText,
  bannerImage,
  textAlign,
  textStyles,
  textColor,
  buttonType
}) {
  // Helper function to safely get theme values
  const getThemeColor = (colorKey) => {
    try {
      const themeObj = theme;
      const color = themeObj.colors[colorKey];
      return color || colorKey;
    } catch (error) {
      console.warn('Error accessing theme color:', error);
      return colorKey;
    }
  };

  const getThemeStyle = (styleKey) => {
    try {
      const style = theme.styles[styleKey];
      return style?.h5 || {};
    } catch (error) {
      console.warn('Error accessing theme style:', error);
      return {};
    }
  };




  const productContent = (
    <>
      <div className="product-grid-item" style={{border: "1px solid rgba(82,102,101,.15)", borderRadius: "8px", padding:"20px 10px 20px 10px"}}>
        <div className="product__image" style={{height: "230px", textAlign: "center"}}>
          <div className="image__container">
            <img src={image} className="blur-up lazyautosizes ls-is-cached lazyloaded" width="220" height="220" data-sizes="auto" alt={alt} sizes="181px" />
          </div>
          {bannerImage && (
            <div className="banner_holder">
              <div
                className="flag thumbnail_banner"
                style={{backgroundImage: `url(${bannerImage})`,
              position: "relative", backgroundSize: "contain", width: "250px", height: "80px", left: "-42px", top: "-283px"}}
              ></div>
            </div>
          )}
        </div>

        <div style={{ textAlign: textAlign || "center"}}>
          <h5 
            style={{
              color: textColor && textColor !== 'default' ? getThemeColor(textColor) : "rgb(77, 82, 84)",
              ...(textStyles && textStyles !== 'default' ? getThemeStyle(textStyles) : {})
            }}
          >
            <strong>{title1}</strong>
          </h5>
          <h5 
            style={{
              color: textColor && textColor !== 'default' ? getThemeColor(textColor) : "rgb(77, 82, 84)",
              ...(textStyles && textStyles !== 'default' ? getThemeStyle(textStyles) : {})
            }}
          >
            <strong>{title2}</strong>
          </h5>
          <p style={{color: "rgb(77, 82, 84)", marginBottom: "10px"}}>{subtitle}</p>
        </div>

        <div style={{ textAlign: "center" }}>
          <Button
            as="div"
            variant={buttonType === 'arrow' || buttonType === 'primaryMando' ? 'primary' : (buttonType || 'primary')}
            sx={{
              minWidth: '200px',
              textDecoration: 'none !important',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '12px 20px',
              '&:visited': {
                textDecoration: 'none !important',
              },
              '&:hover': {
                textDecoration: 'none !important',
              },
              '&:active': {
                textDecoration: 'none !important',
              },
              '&:focus': {
                textDecoration: 'none !important',
              },
              '&:before' : {
                border: 'none !important',
                marginLeft: '0 !important',
              },
              '&:after': {
                display: 'none',
                content: 'none',
              },
            }}
          >
            <div style={{ fontWeight: 'bold', marginBottom: '4px' }}>{buttonText}</div>
            <div style={{ fontSize: '14px', lineHeight: '1.2' }}>
              <span style={{textDecoration: "line-through", color: "#e2e8e8"}}>{strikedPrice}</span> {price}
            </div>
          </Button>
        </div>
      </div>

      <div style={{ textAlign: "center"}}>
        <p><strong style={{color: "rgb(66, 186, 133)"}}>{bottomText}</strong></p>
      </div>
    </>
  );

  return (
    <Box>
      {productContent}
    </Box>
  );
}
